import { styled } from "theme/default/styled";

export const SActionCloseButton = styled.button`
  position: absolute;
  top: -6px;
  right: 6px;
`;
